var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu_Setting'),_c('Unit_Setting')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }